import { useEffect } from 'react';

// :focus-visible alone isn't enough: browsers match it on text fields even when clicked with a mouse,
// so every input, chat box and form would gain a ring on click and change the look of customers' branded sites.
// This tracks whether focus came from Tab, so text fields only show the focus ring for keyboard users.
export const useFocusSource = () => {
	useEffect(() => {
		const root = document.documentElement;

		const handleKeyDown = (event: KeyboardEvent) => {
			if (event.key !== 'Tab') return;
			root.dataset.focusSource = 'keyboard';
		};

		const handlePointerDown = () => {
			root.dataset.focusSource = 'pointer';
		};

		window.addEventListener('keydown', handleKeyDown, true);
		window.addEventListener('pointerdown', handlePointerDown, true);

		return () => {
			window.removeEventListener('keydown', handleKeyDown, true);
			window.removeEventListener('pointerdown', handlePointerDown, true);
			delete root.dataset.focusSource;
		};
	}, []);
};
